/* theme.js — Outland Trailers
   Place any additional JavaScript here.
   Core JS (mobile nav, counters, form stepper) lives in theme.liquid.
*/

document.addEventListener('DOMContentLoaded', function () {

  /* Auto-submit cart quantity changes */
  var cartForm = document.querySelector('form[action="/cart"]');
  if (cartForm) {
    cartForm.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.addEventListener('change', function () {
        cartForm.submit();
      });
    });
  }

  /* Smooth scroll for anchor links */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
